import { TranslateModule } from "@ngx-translate/core";
import { Component, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogModule } from "@angular/material/dialog";

import { ButtonComponent } from "../../button/button.component";

@Component({
  selector: "app-empty-dialog",
  standalone: true,
  imports: [TranslateModule, MatDialogModule, ButtonComponent],
  templateUrl: "./empty-dialog.component.html",
  styleUrl: "./empty-dialog.component.scss",
})
export class EmptyDialogComponent {
  private data = inject(MAT_DIALOG_DATA);

  message = this.data.message;
}
